import { getRuntimeConfig } from '../lib/runtimeConfig';

/* istanbul ignore next */
const publicRuntimeConfig = getRuntimeConfig() || {};

export const buildApiUrl = (suffix: string) => {
  return `${publicRuntimeConfig.originUrl}/api/${suffix}`;
};

export const buildRevGeocodeUrl = (
  lat: string | number,
  lon: string | number
) => {
  return buildApiUrl(`here/revgeocode?lat=${lat}&lon=${lon}`);
};

export const buildSimilarUrl = (locationId: string | number) => {
  return buildApiUrl(`similar?locationId=${locationId}`);
};

export const buildTopUrl = (locationId: string | number) => {
  return buildApiUrl(`top?locationId=${locationId}`);
};

export const buildAutocompleteUrl = (query: string, type: string) => {
  let endpoint = `here/autocomplete?q=${encodeURIComponent(query)}`;
  if (type === 'projects') {
    endpoint = endpoint + '&type=projects';
  }
  return buildApiUrl(endpoint);
};

export const buildCommunicationStatusUrl = (
  bidPackageId: number,
  companyId: number,
  loginInformationId: number,
  userCompanyId: number | null
) => {
  let params = `?bidPackageId=${bidPackageId}&companyId=${companyId}&loginInformationId=${loginInformationId}`;
  if (userCompanyId) {
    params = params + `&userCompanyId=${userCompanyId}`;
  }
  return buildApiUrl(`bid-packages/communication-status${params}`);
};

export const buildGraphqlUrl = () => {
  return `${publicRuntimeConfig.selfUrl}/graphql`;
};

export const buildCurrentUserUrl = () => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v1.0/me`
    : undefined;
};

export const buildMonolithCompanyUrl = (companyId: string | number) => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v1.0/companies/${companyId}?view=pcn`
    : undefined;
};

export const buildMonolithCompaniesUrl = () => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v1.0/companies?include_free_companies=true&per_page=100`
    : undefined;
};

export const buildCompanyContactUrl = (companyId: string | number) => {
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v1.0/companies/${companyId}/me`
    : undefined;
};

export const buildMonolithCommunicationStatusUrl = (
  bidPackageId: number,
  loginInformationId: number,
  userCompanyId: number | null
) => {
  if (!publicRuntimeConfig.procoreApiDomain) {
    return undefined;
  }
  let url = `${publicRuntimeConfig.procoreApiDomain}/rest/v2.0/internal/public_bid_packages/${bidPackageId}/communication_status?login_information_id=${loginInformationId}`;
  if (userCompanyId) {
    url = url + '&subcontractor_company_id=' + userCompanyId;
  }
  return url;
};

export const buildMonolithProjectUrl = (projectSlug: string | number) => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v2.0/internal/public_bid_packages/${projectSlug}/details`
    : undefined;
};

export const buildPayingEntitlementUrl = (companyId: string | number) => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v1.0/companies/${companyId}/entitlements/paying_status`
    : undefined;
};

export const buildAMSCreateOrgApiUrl = () => {
  if (process.env.STAGE === 'production') {
    return `${publicRuntimeConfig.procoreApiDomain}/ams/organizations`;
  }
  return 'https://staging1.procoretech-qa.com/ams/organizations';
};

export const buildAMSCreateAccountApiUrl = (orgId: string | number) => {
  if (process.env.STAGE === 'production') {
    return `${publicRuntimeConfig.procoreApiDomain}/ams/organizations/${orgId}/accounts/procore`;
  }
  return `https://staging1.procoretech-qa.com/ams/organizations/${orgId}/accounts/procore`;
};

export const buildBidPackageManifestUrl = (bidPackageId: number) => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v2.0/internal/public_bid_packages/${bidPackageId}/public_bid_docs_manifest`
    : undefined;
};

export const buildMonolithCommunicationsUrl = (bidPackageId: number) => {
  /* istanbul ignore next */
  return publicRuntimeConfig.procoreApiDomain
    ? `${publicRuntimeConfig.procoreApiDomain}/rest/v2.0/internal/public_bid_packages/${bidPackageId}/communications`
    : undefined;
};

export const buildCommunicationsApiUrl = () => {
  return buildApiUrl('bid-packages/communications');
};
